import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import MenuIcon from "@mui/icons-material/Menu";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";

import { useGetSeachParam } from "../../useSearchParams";
import usePublicInteraction from "../../Interaction/usePublicInteraction";
import SearchBar from "./SearchBar";
import ShareDialog from "./ShareDialog";
import RemoveSurveyDialog from "./RemoveSurveyDialog";

export default function CustomToolbar({ open, setOpen, myPractitionerCode }) {
  const interactionId = Number(useGetSeachParam("i"));
  const editInteraction = { interactionId: interactionId, interaction: null };
  const { t } = useTranslation();

  // local state
  const [openDialog, setOpenDialog] = useState({
    open: false,
    type: "remove",
  });

  // server state
  const { publicInteraction, refetchPublicInteraction } =
    usePublicInteraction(interactionId);
  const isEditable = publicInteraction?.from?.code === myPractitionerCode; // editable if I'm the editor
  const publicStatus = publicInteraction?.from?.public;

  return (
    <Box height={"100%"}>
      <Box
        sx={{
          background: "background.default",
          color: "text.primary",
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          paddingRight: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box display={"flex"} width={"100%"}>
          {!open ? (
            <IconButton onClick={() => setOpen((prev) => !prev)} size="large">
              <MenuIcon />
            </IconButton>
          ) : null}
          <SearchBar />
        </Box>
        {interactionId ? (
          <div style={{ display: "flex", gap: 16 }}>
            <Button
              variant="outlined"
              startIcon={<EditOutlinedIcon />}
              component={Link}
              to={{
                pathname: "/editor",
                state: editInteraction,
              }}
            >
              {t("common.buttons.edit")}
            </Button>
            {isEditable ? (
              <Button
                variant="outlined"
                startIcon={<PeopleOutlinedIcon />}
                onClick={() => setOpenDialog({ type: "share", open: true })}
              >
                {t("common.buttons.share")}
              </Button>
            ) : null}
            {isEditable ? (
              <Button
                variant="outlined"
                startIcon={<DeleteOutlinedIcon />}
                color="secondary"
                onClick={() => setOpenDialog({ type: "remove", open: true })}
              >
                {t("common.buttons.remove")}
              </Button>
            ) : null}
          </div>
        ) : null}
      </Box>
      {openDialog.type === "remove" && openDialog.open ? (
        <RemoveSurveyDialog open={openDialog.open} setOpen={setOpenDialog} />
      ) : null}
      {openDialog.type === "share" && openDialog.open ? (
        <ShareDialog
          open={openDialog.open}
          setOpen={setOpenDialog}
          refetchPublicInteraction={refetchPublicInteraction}
          publicStatus={publicStatus}
        />
      ) : null}
    </Box>
  );
}
